"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.credit.description': 'Configure credit conversion rates for AI services',
    'settings.credit.failedToLoad': 'Failed to load credit settings',
    'settings.credit.savedSuccessfully': 'Credit settings saved successfully',
    'settings.credit.failedToSave': 'Failed to save credit settings',
    'settings.credit.save': 'Save Credit Settings',
    'settings.credit.reload': 'Reload',
    'settings.credit.credits': 'credits',
    'settings.credit.conversion.title': 'Currency Conversion',
    'settings.credit.conversion.dollarToCreditRate': 'Credits per USD',
    'settings.credit.conversion.dollarToCreditRate.help': 'How many credits equal 1 USD. This affects pricing for all AI operations.',
    'settings.credit.preview.title': 'Conversion Preview',
    'settings.credit.warning.title': 'Important Notice',
    'settings.credit.warning.description': 'Changes to credit rates will affect all future AI operations. Existing user credits will not be affected.',
};
